import {  createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var DeleteVehicleTypeRes;
export const DeleteVehicleTypeTodo = createAsyncThunk('AddCategory', async (id) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Delete",
            url: process.env.REACT_APP_API_URL +  `vehicle_type/${id}`,
         
            headers: { "Content-Type": "application/json" , "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return DeleteVehicleTypeRes = res.data
        
    } catch (error) {
        return DeleteVehicleTypeRes = error.response.data
    }
})
